import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function AuthPage({ mode }) {
  const isLogin = mode === "login";
  const { login, register } = useApp();
  const [f, setF] = useState({ name:"", email:"", password:"", phone:"" });
  const [loading, setLoading] = useState(false);
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const next = sp.get("next") || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (isLogin) await login(f.email, f.password);
      else await register(f);
      nav(next);
    } catch (err) { toast.error(err?.response?.data?.detail || "Failed"); } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img src="https://images.unsplash.com/photo-1619898383579-fb0a52a93947?w=1200&q=80" className="absolute inset-0 w-full h-full object-cover" alt=""/>
        <div className="absolute inset-0 bg-gradient-to-br from-primary/70 to-black/50"/>
        <div className="relative p-12 h-full flex flex-col justify-end text-white">
          <h2 className="font-serif text-4xl">Welcome to DivineCart</h2>
          <p className="mt-3 opacity-90 max-w-md">India's most-loved online destination for authentic puja samagri, kits, and spiritual essentials.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="section-label">{isLogin?"Sign In":"Create Account"}</div>
          <h1 className="font-serif text-4xl mt-2">{isLogin?"Namaste, welcome back":"Namaste, join us"}</h1>
          <div className="mt-8 space-y-3">
            {!isLogin && <input data-testid="auth-name" required className="pk-input" placeholder="Full Name" value={f.name} onChange={e=>setF({...f, name:e.target.value})}/>}
            <input data-testid="auth-email" required type="email" className="pk-input" placeholder="Email" value={f.email} onChange={e=>setF({...f, email:e.target.value})}/>
            {!isLogin && <input data-testid="auth-phone" className="pk-input" placeholder="Mobile (optional)" value={f.phone} onChange={e=>setF({...f, phone:e.target.value})}/>}
            <input data-testid="auth-password" required type="password" className="pk-input" placeholder="Password (min 6 chars)" value={f.password} onChange={e=>setF({...f, password:e.target.value})}/>
          </div>
          <button data-testid="auth-submit" disabled={loading} className="pk-btn-primary w-full mt-6">{loading?"Please wait...":(isLogin?"Sign In":"Create Account")}</button>
          <div className="mt-4 text-sm text-center text-muted-foreground">
            {isLogin ? <>New here? <Link to="/register" className="text-primary underline">Create an account</Link></> :
             <>Already have an account? <Link to="/login" className="text-primary underline">Sign in</Link></>}
          </div>
        </form>
      </div>
    </div>
  );
}
